import { useCallback, useState } from 'react';
import { client } from '../../api/client';

/** Balance values exposed by the current user profile. */
export interface ProfileState {
  isLoggedIn: boolean;
  isAnonymous: boolean; // <-- Новый флаг
  userId: string;
  userName: string;
  generationsBalance: number;
  vocalGenerationsBalance: number;
  tracksBalance: number;
  additionalGenerationBalance: number;
  savedSongsCount: number;
}

const INITIAL_STATE: ProfileState = {
  isLoggedIn: false,
  isAnonymous: true,
  userId: '',
  userName: '',
  generationsBalance: 0,
  vocalGenerationsBalance: 0,
  tracksBalance: 0,
  additionalGenerationBalance: 0,
  savedSongsCount: 0,
};

/** React state and loaders for the authenticated or anonymous profile. */
export function useProfile() {
  const [profile, setProfile] = useState<ProfileState>(INITIAL_STATE);

  const load = useCallback(async () => {
    const data = await client.user.getProfile();
    // Определяем, аноним ли это, по отсутствию поля name (согласно схеме)
    const isAnon = !('name' in data);

    setProfile({
      isLoggedIn: true,
      isAnonymous: isAnon,
      userId: data.id,
      userName: isAnon ? 'Гость' : data.name,
      generationsBalance: data.balances.GENERATION ?? 0,
      vocalGenerationsBalance: data.balances.GENERATION_VOICE ?? 0,
      tracksBalance: data.balances.TRACK_UNLOCK ?? 0,
      additionalGenerationBalance: data.balances.ADDITIONAL_GENERATION ?? 0,
      savedSongsCount: data.savedSongsCount,
    });
  }, []);

  const reset = useCallback(() => {
    localStorage.removeItem('token');
    setProfile(INITIAL_STATE);
  }, []);

  const patch = useCallback((partial: Partial<ProfileState>) => {
    setProfile((prev) => ({ ...prev, ...partial }));
  }, []);

  return { profile, load, reset, patch };
}